export default __webpack_public_path__ + "assets/roboto-v18-latin-regular.cb41c1e.woff2";